import React, {useContext, useState, useEffect } from 'react';
import InputField from "@FormElements/InputField";
import SelectField from "@FormElements/SelectField";
import FormContext from "formContext";
import axios from "axios";
import Logger from '@ffw/logger-lib';

function PostalAutosuggestField({settings, ...rest}) {
  const {additionalData, setAdditionalData, currentStep, formData, setFormData} = useContext(FormContext);
  const [data, setData] = useState([]);
  const [cityDisabled, setCityDisabled] = useState(true);
  const classes ="disabled-dropdown";
  const {onChange} = rest;

  useEffect(() => {
    if (formData[currentStep] && formData[currentStep].hasOwnProperty(settings.name)) {
      let input = document.querySelector(`input[name="${settings.name}"]`);
      input.value = formData[currentStep][settings.name];
      let event = new Event('input', { bubbles: true });
      input._valueTracker.setValue('');
      input.dispatchEvent(event);
    }
  }, [formData[currentStep]]);

  useEffect(() => {
    if (Object.keys(data).length > 1) {
      setCityDisabled(false);
    } else {
      setCityDisabled(true);
    }
  }, [data]);

  const handlePostalCodeChange = e => {
    let value = e.target.value;

    let newCityOptions = [];

    if (value) {
      axios.get(`/api/search/get-atome-data?collection=data&callback=GetTownsByPostalCode&props[]=${value}`)
        .then(result => {

          if (result.data.length) {
            result.data.forEach(item => {
              if (item.hasOwnProperty('Key') && item.hasOwnProperty('Value')) {
                newCityOptions.push({value: item.Key, label: item.Value});
              }
            });

            newCityOptions.sort(function (a, b) {
              if (a.label < b.label) {
                return -1;
              }
              if (a.label > b.label) {
                return 1;
              }
              return 0;
            });

            setData(newCityOptions);
          } else {
            setData([]);
          }

          setAdditionalData(prev => {
            return {
              ...prev,
              cities: newCityOptions
            }
          });

          setFormData(prev => {
            if (!prev[currentStep]) {
              prev[currentStep] = {};
            }

            if (newCityOptions && newCityOptions[0] && newCityOptions[0].value) {
              let selectedUserCity;
              if (additionalData && additionalData.user && additionalData.user.atomeData && additionalData.user.atomeData.Location && additionalData.user.atomeData.Location.TownID) {
                selectedUserCity = newCityOptions.find(c => c.value === additionalData.user.atomeData.Location.TownID);
              }
              prev[currentStep][settings.cityFieldName] = (selectedUserCity && selectedUserCity.value) ? selectedUserCity.value : newCityOptions[0].value;
            } else {
              prev[currentStep][settings.cityFieldName] = "";
            }
            return {
              ...prev
            }
          });
        })
        .catch(error => {
          Logger.error(`Error getting postal code suggested values: ${error.message}`, "PostalAutosuggestField/fr");
        });
    }

    setFormData(prev => {
      if (!prev[currentStep]) {
        prev[currentStep] = {};
      }
      prev[currentStep][settings.name] = value;
      return {
        ...prev
      }
    });

    onChange(e);
  };

  const handleCityChange = e => {
    let value = e.target.value;

    setFormData(prev => {
      if (!prev[currentStep]) {
        prev[currentStep] = {};
      }
      prev[currentStep][settings.cityFieldName] = value;
      return {
        ...prev
      }
    });

    onChange(e);
  }

  return (
    <>
      <InputField
        settings={settings}
        {...rest}
        onChange={handlePostalCodeChange}
      />
      <SelectField
        name={settings.cityFieldName}
        disabled={cityDisabled}
        required={true}
        settings={
          {
            divClasses: classes,
            label: "Register.Form.City.Label",
            options: data
          }
        }
        onChange={handleCityChange}
        value={(settings.state && settings.state.TownID) ? settings.state.TownID : ''}
      />
    </>
  );
}

export default PostalAutosuggestField;